import React from "react";
import { Container, Button } from "react-bootstrap";
import { useGuestContext } from "../../contexts/GuestContext";
import Swal from "sweetalert2";

// Import dashboards
import ChingMingDashboard from "./ChingMingDashboard";
import BudhaBathDashboard from "./BudhaBathDashboard";
import VegeFestDashboard from "./VegeFestDashboard";
import BaolinDashboard from "./BaolinDashboard";

function Dashboard() {
    const { viewingEvent, switchEvent } = useGuestContext();

    const getEventDisplayName = (eventType) => {
        const eventNames = {
            'lianghuang': '梁皇寶懺精進共修法會',
            'budhabath': '浴佛節法會',
            'vegefest': '素食展',
            'chingming': '藥師寶懺法會',
            'newyear': '新年法會',
            'default': '法會未選擇'
        };
        return eventNames[eventType] || eventNames.default;
    };

    const handleEventSelect = () => {
        Swal.fire({
            title: 'Select an event',
            input: 'select',
            inputOptions: {
                'chingming': '藥師寶懺法會',
                'budhabath': '浴佛節法會',
                'lianghuang': '梁皇寶懺共修法會',
                'vegefest': '素食展',
                'newyear': '新年法會'
            },
            inputPlaceholder: 'Select an event',
            inputValue: viewingEvent || 'chingming', // Default to chingming if null
            showCancelButton: true,
            inputValidator: (value) => {
                return new Promise((resolve) => {
                    if (value !== '') {
                        resolve();
                    } else {
                        resolve('You need to select an event');
                    }
                });
            }
        }).then((result) => {
            if (result.isConfirmed) {
                switchEvent(result.value);
                Swal.fire(`切換至 ${getEventDisplayName(result.value)} 的 Dashboard`);
            }
        });
    };

    // Make sure we have a valid viewingEvent to start, default to chingming
    React.useEffect(() => {
        if (!viewingEvent || viewingEvent === 'default' || viewingEvent === '3R5P') {
            switchEvent('chingming');
        }
    }, [viewingEvent, switchEvent]);

    const renderDashboard = () => {
        switch (viewingEvent) {
            case 'chingming':
                return <ChingMingDashboard />;
            case 'budhabath':
                return <BudhaBathDashboard />;
            case 'vegefest':
                return <VegeFestDashboard />;
            case 'lianghuang':
            case 'newyear':
                return <BaolinDashboard />; // Default to main baolin dashboard for others
            default:
                return <ChingMingDashboard />;
        }
    };

    return (
        <Container fluid>
            <div className="d-flex justify-content-end mb-3">
                <Button variant="primary" onClick={handleEventSelect}>
                    目前法會: {getEventDisplayName(viewingEvent)} (點擊切換)
                </Button>
            </div>
            {renderDashboard()}
        </Container>
    );
}

export default Dashboard;
